import { render } from "./AnimatedArrowIcon.vue?vue&type=template&id=7a3bc7f0&scoped=true"
const script = {}

import "./AnimatedArrowIcon.vue?vue&type=style&index=0&id=7a3bc7f0&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3bc7f0"]])

export default __exports__